import { useState, useEffect } from "react";
import UI_Input_Text from "./UI_Input_Text";
import UI_Icon from "./UI_Icons";
import UI_Horizontal_Tabs from "./UI_Horizontal_Tabs";
import UI_UpdatingStatus from "./UI_UpdatingStatus";
import UI_Divider from "./UI_Divider";

export default function UI_List_Manager({
    id,
    Title,
    Input = [],
    Filters = {},
    Filter_Selected = "Tab_All",
    Keys_Searchable = [],
    Options_Sort = [],
    Output,
    Options_Display = {Composition: false}
}) {
    const [Query, Query_Set] = useState("");
    const [Filters_Active, Filters_Active_Set] = useState({});
    const [Sort, Sort_Set] = useState(Options_Sort[0] || null);
    const [Data_Filtered, Data_Filtered_Set] = useState(Input);

    const Filters_Apply = (Data, Filter_State, Filter_Configuration) => {
        return Data.filter(Item => {
            return Object.entries(Filter_State).every(([Filter_Key, Selected]) => {
                const Configuration = Filter_Configuration[Filter_Key];
                if (!Configuration || Selected === "All") return true;
                if (typeof Configuration.Logic === "function") {
                    return Configuration.Logic(Item, Selected);
                }

                return Item[Filter_Key] === Selected;
            })
        })
    }

    useEffect(() => {
        try {
            let Result = [...Input];

            if (Query.trim() !== "") {
                Result = Result.filter(Item =>
                    Keys_Searchable.some(Key =>
                        String(Item[Key] ?? "")
                            .toLowerCase()
                            .includes(Query.toLowerCase())
                    )
                );
            }

            // Object.entries(Filters_Active).forEach(([Key, Value]) => {
            //     if (Value && Value !== "All") {
            //         Result = Result.filter(Item => Item[Key] === Value);
            //     }
            // });

            Result = Filters_Apply(Result, Filters_Active, Filters);

            const getNestedValue = (obj, path) => {
                if (!path) return obj;
                return path.split('.').reduce((acc, part) => acc && acc[part], obj);
            }

            if (Sort) {
                // Check if the sorter object provides its own custom logic
                if (typeof Sort.Logic === "function") {
                    Result.sort(Sort.Logic);
                }
                // Otherwise, use the key/direction logic (now with nested support)
                else if (Sort.Key) {
                    Result.sort((a, b) => {
                        const A = getNestedValue(a, Sort.Key);
                        const B = getNestedValue(b, Sort.Key);

                        if (A < B) return Sort.Direction === "Ascending" ? -1 : 1;
                        if (A > B) return Sort.Direction === "Ascending" ? 1 : -1;
                        return 0;
                    });
                }
            }

            if (Sort) {
                Result.sort((a, b) => {
                    const A = a[Sort.Key];
                    const B = b[Sort.Key];
                    if (A < B) return Sort.Direction === "Ascending" ? -1 : 1;
                    if (A > B) return Sort.Direction === "Ascending" ? 1 : -1;
                    return 0;
                });
            }

            Data_Filtered_Set(Result);
        } catch (Error) {
            console.error(Error);
        }
        
    }, [Input, Query, Filters_Active, Sort]);



    return (
        <div className="List_Manager" data-ui="list-manager" Composition={Options_Display?.Composition === "Linear" ? "Linear" : undefined}>
            <div className="List_Manager_Controls" >
                {/* <UI_Icon Name="Search" /> */}
                <UI_Input_Text
                    Input_Placeholder="Search..."
                    onChange={(e) => Query_Set(e.target.value)}
                />

                {Object.keys(Filters)?.length > 0 && (
                    <div className="List_Manager_Filters">
                        <p className="General_Paragraph">Filter:</p>
                        {Object.entries(Filters)?.map(([FilterKey, FilterConfig]) => (
                            <UI_Horizontal_Tabs
                                key={FilterKey}
                                id={`${id}_Filter_${FilterKey}`}
                                Selectors={[
                                    { Text: "All", Icon: <UI_Icon Name="List" /> },
                                    ...FilterConfig.Options.map(value => ({
                                        Text: value.Label,
                                        Icon: value.Icon,
                                    })),
                                ]}
                                UIDs={["All", ...FilterConfig.Options.map(opt => opt.Label)]}
                                SelectorsOnly={true}
                                onChange={(Data) => {
                                    const NormalizedValue = Data.replace(/^Tab_/, "");
                                    Filters_Active_Set({
                                        ...Filters_Active,
                                        [FilterKey]: NormalizedValue,
                                    });
                                }
                                }
                                Selected={Filter_Selected}
                                NoStretch={true}
                            />
                        ))}
                    </div>
                )}
            </div>

            {Options_Sort?.length > 0 && (
                <div className="List_Manager_Sorters">
                    <p className="General_Paragraph">Sort:</p>
                    <UI_Horizontal_Tabs
                        id={`${id}_Sorters`}
                        Selectors={Options_Sort?.map((opt) => ({
                            Text: opt.Label,
                            Icon: <UI_Icon Name="Sort" />,
                        }))}
                        UIDs={Options_Sort?.map((opt) => opt.Label)}
                        SelectorsOnly={true}
                        onChange={(Label) => {
                            const NormalizedLabel = Label.replace(/^Tab_/, "");
                            const Selected = Options_Sort?.find(
                                (o) => o.Label === NormalizedLabel || o.Label === Label
                            );
                            Sort_Set(Selected);
                        }}
                        Selected={`Tab_${Options_Sort[0]?.Label}`}
                        NoStretch={true}
                    />
                </div>
            )}

            <div className="List_Manager_Results">
                <UI_UpdatingStatus
                    id={`${id}_Outputs`}
                    State={Data_Filtered?.length <= 0 ? "Bad" : "Good"}
                    Bad={{
                        Type: "Custom",
                        Content: (
                            <p className="General_Paragraph">No results found.</p>
                        ),
                    }}
                    Good={{
                        Type: "Custom",
                        Content: (
                            <>
                                {Query ?
                                    <UI_Divider Text={`${Data_Filtered?.length} results for '${Query}'`} />
                                    :
                                    <UI_Divider Text={`${Data_Filtered?.length} results`} />
                                }
                                {/* <p className="General_Paragraph" style={{ marginBottom: "5px" }}>{Data_Filtered.length} results</p> */}
                                {/* <div className="General_List"> */}
                                <div className="General_List">
                                    {Data_Filtered?.map((Item, Index) => (
                                        Output(Item)
                                    ))}
                                </div>
                                
                                <UI_Divider />
                                {/* </div> */}

                            </>
                        ),
                    }}
                />
            </div>
        </div>
    );
}
